// config
import * as http from 'utils/http';
import config from 'config';

const assignTicket = async ({ assignTicketDto }) => {
  return http.post(`${config.API_URL}price-negotiation/tickets/assignments/`, assignTicketDto);
};

export default assignTicket;
